// react, redux-form
import React from "react";
import { Field } from "redux-form";

// helpers
import { formatCurrency } from "../../helpers/renderHelpers";
import { fileUploaded } from "../../helpers/actionsHelpers";
import { required } from "../../helpers/validate";

// render components
import ReviewField from '../global/ReviewField/ReviewField';
import RenderField from "../global/RenderField";

let ReviewContent = props => {
  const { formName, formData, attachments, jumpToPage } = props;

  let owners = [];
  if (formData.owners) {
    let numrows = formData.owners.length;
    for (var i = 0; i < numrows; i++) {
      owners.push(
        <ReviewField key={i} formData={formData} formName={formName} type="contactArray" arrayPosition={i} propertyName="owners" title={`Owner #` + (i + 1)} />
      );
    }
  }

  return (
    <div>
      {(formData.vhrNumber || formData.address || formData.placeObjectName) && (
        <div className="review--section-wrapper">
          <h3 className="review--section-wrapper-title">Property details</h3>
          {formData.placeObjectName && (<ReviewField formData={formData} formName={formName} type="description" propertyName="placeObjectName" title="Place or object" />)}
          {formData.vhrNumber && (<ReviewField formData={formData} formName={formName} type="description" propertyName="vhrNumber" title="VHR number" />)}
          {formData.address && (<ReviewField formData={formData} formName={formName} type="propertyAddress" propertyName="address" title="Address" />)}
        </div>
      )}
      {(formData.preApplicationDiscussion) && (
        <div className="review--section-wrapper">
          <ReviewField formData={formData} formName={formName} type="editButton" jumpToPage={jumpToPage} page={1}/>
          <h3 className="review--section-wrapper-title">Application meeting details</h3>
          {formData.preApplicationDiscussion && (<ReviewField formData={formData} formName={formName} type="description" propertyName="preApplicationDiscussion" title="Pre-application discussion" />)}
          {formData.preApplicationDiscussion && formData.preApplicationDiscussion === 'true' && formData.preApplicationEventNumber && (<ReviewField formData={formData} formName={formName} type="description" propertyName="preApplicationEventNumber" title="P-Number" />)}
        </div>
      )}
      {(formData.primaryContact || formData.applicant || formData.owners || formData.ownersCorpManagerDetails) && (
        <div className="review--section-wrapper">
          <ReviewField formName={formName} type="editButton" jumpToPage={jumpToPage} page={1}/>
          <h3 className="review--section-wrapper-title">Contact details</h3>
          {formData.primaryContact && (<ReviewField formData={formData} formName={formName} type="contact" propertyName="primaryContact" title="Primary contact" />)}
          {formData.applicant && (<ReviewField formData={formData} formName={formName} type="contact" propertyName="applicant" title="Applicant" />)}
          {formData.owners && owners}
          {formData.isCommonPropertyInvolved && formData.isCommonPropertyInvolved === 'false' && (
            <div className="review--section-details-wrapper">
              <h4 className="review--section-details-title">Do the works involve common property</h4>
              <p className="review--section-details-value">No</p>
            </div>
          )}
          {formData.isCommonPropertyInvolved && formData.isCommonPropertyInvolved === 'true' && formData.ownersCorpManagerDetails && (
            <ReviewField formData={formData} formName={formName} type="contact" propertyName="ownersCorpManagerDetails" title="Owners corporation manager" />
          )}
        </div>
      )}
      {(formData.permitType || formData.permitTypeEstimatedCost ||  formData.detailedDescriptionOfProposedWorks || formData.reasonAndPurposeOfProposedWorks || formData.impactOfProposedWorks || formData.estimatedCostOfWorks) && (
        <div className="review--section-wrapper">
          <ReviewField formData={formData} formName={formName} type="editButton" jumpToPage={jumpToPage} page={2}/>
          <h3 className="review--section-wrapper-title">
            Proposed work details
          </h3>
          {formData.workCategories && formData.workCategories.length > 0 && (<ReviewField formData={formData} formName={formName} type="list" propertyName="workCategories" title="Work categories" />)}
          {formData.detailedDescriptionOfProposedWorks && (<ReviewField formData={formData} formName={formName} type="description" propertyName="detailedDescriptionOfProposedWorks" title="Description of proposed works" />)}
          {formData.reasonAndPurposeOfProposedWorks && (<ReviewField formData={formData} formName={formName} type="description" propertyName="reasonAndPurposeOfProposedWorks" title="Reason of proposed works" />)}
          {formData.impactOfProposedWorks && (<ReviewField formData={formData} formName={formName} type="description" propertyName="impactOfProposedWorks" title="Impact of proposed works" />)}
          {formData.estimatedCostOfWorks && (<ReviewField formData={formData} formName={formName} type="description" format={formatCurrency} propertyName="estimatedCostOfWorks" title="Estimated cost of works" />)}
        </div>
      )}
      {fileUploaded(attachments) && (
          <div className="review--section-wrapper">
          <ReviewField formData={formData} formName={formName} type="editButton" jumpToPage={jumpToPage} page={3}/>
          <h3 className="review--section-wrapper-title">Uploaded files</h3>
          <ReviewField formData={formData} formName={formName} type="list" listType="upload" autoWidth />
        </div>
      )}
      <div className="review--section-wrapper">
        <h3 className="review--section-wrapper-title">Declarations</h3>
        <Field
          name="hasOwnerProvidedConsent"
          type="checkbox"
          component={RenderField}
          templateList={formData.owners.length === 1 && formData.sameAsPrimaryContact && formData.sameAsPrimaryContact.length > 0 && formData.sameAsPrimaryContactApplicant ? [
            {
              name:
                "I am the owner or government manager of the registered place or registered object described in this permit application and I hereby consent to the application to carry out the works or activities specified in the application.",
              value: "true"
            }
          ] : [
            {
              name:
                "I declare that in accordance with s93(3) of the Heritage Act 2017, I have obtained the written consent of the owners or government manager to carry out the works or activities specified in this application.",
              value: "true"
            }
          ]}
          validate={required}
          required
        />
        {formData.isCommonPropertyInvolved &&
          formData.isCommonPropertyInvolved === 'true' && (
            <Field
              name="hasOwnerCorpManagerProvidedConsent"
              type="checkbox"
              component={RenderField}
              templateList={[
                {
                  name:
                    "I declare that the owners corporation has given consent for the works specified in this application.",
                  value: "true"
                }
              ]}
              validate={required}
              required
            />
          )}
        <Field
          name="isApplicantStatementAgreed"
          type="checkbox"
          component={RenderField}
          templateList={[
            {
              name:
                "I state that I am authorised to make this application in relation to the above property or object, and that the information supplied in this application is accurate and correct. I acknowledge that authorised officers appointed by the Executive Director or any member of the Heritage Council may inspect the heritage place or heritage object to assess the application in accordance with the Act.",
              value: "true"
            }
          ]}
          validate={required}
          required
        />
      </div>
    </div>
  );
};

export default ReviewContent;
